import { IRR } from "./irr-lib.helper";
import { getScenarioAgg } from "./scenario.helper";

export const engineHelper = {
  execSimulation,
  getCapitaliComplementari,
  getACMAIS
};

// Declare user inputs
let eta; // D4
let isClientePiuGenerali; // D5
let PUIniziale; // D6
let scenario; // D14
let dirittiEmissione; // D15
let imposteSuiPremiInfortuni; // D16
let vuoiFamilyCare; // D17
let vuoiTCMPU; // D18
let vuoiACMA; // D19
let orizzonteTemporale; // D20
let tutelaClima; // E8
let pariOpportunita; // E9
let consumoResponsabile; // E10
let saluteBenessere; // E11
let crescitaSostenibile; // E12
let familyCareCopertura; // E38
let TCMPUCopertura; // E39
let ACMAPUCopertura; // E40
let ACMAPlusCopertura; // E41
let servizioBilancia;

// Initialize constants
const investimentoGS = 0.4; // D55
let investimentoOICR = 0.1; // D56
let investimentoGS2anni = 0.4; // D57
const dirittiEmissionePU = 10; // D58
const caricamentoPU = 150; // D59
const dirittiEmissioneVA = 2.5; // D60
const caricamentoVA = 100; // D61
const trattenutoGS = 0.0175; // D62
const costoRiscatto = 10; // AV

const terTotaleTutelaClima = 0.0294; // O39
const terTotalePariOpportunita = 0.0278; // P39
const terTotaleConsumoResponsabile = 0.0283; // Q39
const terTotaleSaluteBenessere = 0.0287; // R39
const terTotaleCrescitaSostenibile = 0.0281; // S39

const terTransazioneTutelaClima = 0.00; // O40
const terTransazionePariOpportunita = 0.00; // P40
const terTransazioneConsumoResponsabile = 0.00; // Q40
const terTransazioneSaluteBenessere = 0.00; // R40
const terTransazioneCrescitaSostenibile = 0.00; // S40

const commGestAnnualeTutelaClima = 0.0185; //O41
const commGestAnnualePariOpportunita = 0.0185; //P41
const commGestAnnualeConsumoResponsabile = 0.0185; //Q41
const commGestAnnualeSaluteBenessere = 0.0185; //R41
const commGestAnnualeCrescitaSostenibile = 0.0185; //S41

const commGestMensileTutelaClima = 0.0183439387370228; //O42
const commGestMensilePariOpportunita = 0.0183439387370228; //P42
const commGestMensileConsumoResponsabile = 0.0183439387370228; //Q42
const commGestMensileSaluteBenessere = 0.0183439387370228; //R42
const commGestMensileCrescitaSostenibile = 0.0183439387370228; //S42

const costoOICRTutelaClima = 0.0109; //O43
const costoOICRPariOpportunita = 0.0093; //P43
const costoOICRConsumoResponsabile = 0.0098; //Q43
const costoOICRSaluteBenessere = 0.0102; //R43
const costoOICRCrescitaSostenibile = 0.0096; //S43

const importoInizialeGS = 0.9;

// Declare calculated values
let isFamilyCareAttivabile; // D38
let isTCMPUAttivabile; // D39
let isACMAAttivabile; // D40
let isACMAPlusAttivabile; // D41
let puoiAcquistareFamilyCare; // D21
let puoiAcquistareTCMPU; // D22
let puoiAcquistareACMA; // D23
let premioFamilyCare; // D44
let premioTCMPU; // D45
let premioACMAPUWeight; // D49
let premioACMAPU; // D46
let durataFamilyCare; // E44
let durataTCMPU; // E45
let durataACMAPU; // E46
let tirCostFirstYear; // BF8
let tirCostMidYear; // BF9
let tirCostLastYear; // BF10

let coGS;
let coUL;
let coTransf;

let data = [];

// Example of main
function execSimulation(config) {
  eta = Number(config.eta); // D4
  // console.log("eta", eta);
  isClientePiuGenerali = config.isClientePiuGenerali; // D5
  PUIniziale = Number(config.PUIniziale); // D6
  scenario = config.scenario; // D14
  dirittiEmissione = Number(config.dirittiEmissione); // D15
  imposteSuiPremiInfortuni = Number(config.imposteSuiPremiInfortuni); // D16
  vuoiFamilyCare = config.vuoiFamilyCare; // D17
  vuoiTCMPU = config.vuoiTCMPU; // D18
  vuoiACMA = config.vuoiACMA; // D19
  orizzonteTemporale = Number(config.orizzonteTemporale); // D20
  tutelaClima = Number(config.tutelaClima); // E8
  pariOpportunita = Number(config.pariOpportunita); // E9
  consumoResponsabile = Number(config.consumoResponsabile); // E10
  saluteBenessere = Number(config.saluteBenessere); // E11
  crescitaSostenibile = Number(config.crescitaSostenibile); // E12
  familyCareCopertura = Number(config.familyCareCopertura); // E38
  TCMPUCopertura = Number(config.TCMPUCopertura); // E39
  ACMAPUCopertura = Number(config.ACMAPUCopertura); // E40
  ACMAPlusCopertura = Number(config.ACMAPlusCopertura); // E41
  // ACMAPlusCopertura = 0; // TODO USE A config PARAMS HERE
  servizioBilancia = config.servizioBilancia;

  investimentoOICR = servizioBilancia ? 1 - importoInizialeGS : 0.6; // D56
  investimentoGS2anni = 0.6 - investimentoOICR; // D57

  // Updates calculated values
  isFamilyCareAttivabile = eta >= 18 && eta <= 65 && isClientePiuGenerali; // D38
  isTCMPUAttivabile = eta >= 18 && eta <= 40; // D39
  isACMAAttivabile = eta >= 18 && eta <= 65 && !isClientePiuGenerali; // D40
  isACMAPlusAttivabile = eta >= 18 && eta <= 65 && isClientePiuGenerali; // D41
  puoiAcquistareFamilyCare = isFamilyCareAttivabile; // D21
  puoiAcquistareTCMPU = isTCMPUAttivabile; // D22
  puoiAcquistareACMA = isACMAAttivabile || isACMAPlusAttivabile; // D23
  premioFamilyCare =
    puoiAcquistareFamilyCare && vuoiFamilyCare
      ? familyCareCopertura * 0.001
      : 0; // D44
  premioTCMPU = puoiAcquistareTCMPU && vuoiTCMPU ? TCMPUCopertura * 0.015 : 0; // D45
  premioACMAPUWeight = 0.005; // D49
  premioACMAPU =
    vuoiACMA && puoiAcquistareACMA && isACMAAttivabile
      ? ACMAPUCopertura * premioACMAPUWeight
      : ACMAPlusCopertura * 0.01; // D46
  durataFamilyCare = isFamilyCareAttivabile ? 10 : 0; // E44
  durataACMAPU = premioACMAPU > 0 ? 10 : 0; // E46
  tirCostFirstYear = 1; // BF8
  tirCostMidYear = Math.ceil(orizzonteTemporale / 2); // BF9
  tirCostLastYear = orizzonteTemporale; // BF10
  durataTCMPU = 0; // E45
  if (isTCMPUAttivabile) {
    if (eta > 30) {
      durataTCMPU = 10;
    } else if (eta >= 18) {
      durataTCMPU = 15;
    }
  }
  coGS =
    (getPremioResiduoInvestimento() + getDiritti(1)) * investimentoGS -
    getDiritti(1) -
    caricamentoPU * investimentoGS; // D52
  coUL =
    (getPremioResiduoInvestimento() + getDiritti(1) - getCifraFissa(1)) *
    (investimentoOICR + investimentoGS2anni) // D53
  coTransf =
    ((servizioBilancia ? 1 : 0) * coUL * investimentoGS2anni) /
    (investimentoOICR + investimentoGS2anni); // D54

  data = [];
  let tirCostFirstYearValues = [];
  let tirCostMidYearValues = [];
  let tirCostLastYearValues = [];
  for (let anno = 1; anno <= 25; anno++) {
    let gs = getGS(anno); // X
    let ovp = getOvp(anno); // R
    let retrocessoGestione = getRetrocessoGestione(anno); // S
    let premio = getPremio(anno); // J
    let diritti = getDiritti(anno); // U
    let cifraFissa = getCifraFissa(anno); // V
    let capitaleInizialeLordoDiritti = getCapitaleInizialeLordoDiritti(anno); // T
    let C0MinMorte = getC0MinMorte(anno); // W
    let GSIniziale = getGSIniziale(anno); // X
    let GSFinale = getGSFinale(anno); // AD
    let tutelaClimaIniziale = getTutelaClimaIniziale(anno); // Y
    let tutelaClimaFinale = getTutelaClimaFinale(anno); // AE
    let pariOpportunitaIniziale = getPariOpportunitaIniziale(anno); // Z
    let pariOpportunitaFinale = getPariOpportunitaFinale(anno); // AF
    let consumoResponsabileIniziale = getConsumoResponsabileIniziale(anno); // AA
    let consumoResponsabileFinale = getConsumoResponsabileFinale(anno); // AG
    let saluteBenessereIniziale = getSaluteBenessereIniziale(anno); // AB
    let saluteBenessereFinale = getSaluteBenessereFinale(anno); // AH
    let crescitaSostenibileIniziale = getCrescitaSostenibileIniziale(anno); // AC
    let crescitaSostenibileFinale = getCrescitaSostenibileFinale(anno); // AI
    let prestazioneTotale = getPrestazioneTotale(anno); // AL
    let riscatto = getRiscatto(anno); // AM
    let morte = getMorte(anno); // AN
    let familyCare = getFamilyCare(anno); // AO
    let mortePU = getMortePU(anno); // AP
    let acma = getACMA(anno); // AQ
    let totaleMorte = getTotaleMorte(anno); // AR
    let morteAccidentale = getMorteAccidentale(anno); // AS

    let fineUnitPostRivalBilanciaTutelaClimaValue = getFineUnitPostRivalBilanciaTutelaClima(
      anno
    );
    let fineUnitPostRivalBilanciaConsumoResponsabileValue = getFineUnitPostRivalBilanciaConsumoResponsabile(
      anno
    );
    let fineUnitPostRivalBilanciaCrescitaSostenibileValue = getFineUnitPostRivalBilanciaCrescitaSostenibile(
      anno
    );
    let fineUnitPostRivalBilanciaSaluteBenessereValue = getFineUnitPostRivalBilanciaSaluteBenessere(
      anno
    );
    let fineUnitPostRivalBilanciaPariOpportunitaValue = getFineUnitPostRivalBilanciaPariOpportunita(
      anno
    );

    let residuoGS = getResiduoGS(anno);

    data.push({
      anno: anno,
      premio: premio,
      gs: gs,
      ovp: ovp,
      retrocessoGestione: retrocessoGestione,
      capitaleInizialeLordoDiritti: capitaleInizialeLordoDiritti,
      diritti: diritti,
      cifraFissa: cifraFissa,
      C0MinMorte: C0MinMorte,
      GSIniziale: GSIniziale,
      tutelaClimaIniziale: tutelaClimaIniziale,
      pariOpportunitaIniziale: pariOpportunitaIniziale,
      consumoResponsabileIniziale: consumoResponsabileIniziale,
      saluteBenessereIniziale: saluteBenessereIniziale,
      crescitaSostenibileIniziale: crescitaSostenibileIniziale,
      GSFinale: GSFinale,
      tutelaClimaFinale: tutelaClimaFinale,
      pariOpportunitaFinale: pariOpportunitaFinale,
      consumoResponsabileFinale: consumoResponsabileFinale,
      saluteBenessereFinale: saluteBenessereFinale,
      crescitaSostenibileFinale: crescitaSostenibileFinale,
      prestazioneTotale: prestazioneTotale,
      riscatto: riscatto,
      morte: morte,
      familyCare: familyCare,
      mortePU: mortePU,
      acma: acma,
      totaleMorte: totaleMorte,
      morteAccidentale: morteAccidentale,
      fineUnitPostRivalBilanciaTutelaClimaValue: fineUnitPostRivalBilanciaTutelaClimaValue,
      fineUnitPostRivalBilanciaConsumoResponsabileValue: fineUnitPostRivalBilanciaConsumoResponsabileValue,
      fineUnitPostRivalBilanciaCrescitaSostenibileValue: fineUnitPostRivalBilanciaCrescitaSostenibileValue,
      fineUnitPostRivalBilanciaSaluteBenessereValue: fineUnitPostRivalBilanciaSaluteBenessereValue,
      fineUnitPostRivalBilanciaPariOpportunitaValue: fineUnitPostRivalBilanciaPariOpportunitaValue,
      residuoGS: residuoGS
    });

    tirCostFirstYearValues[anno - 1] = getTirCostValue(anno, tirCostFirstYear); // BF
    tirCostMidYearValues[anno - 1] = getTirCostValue(anno, tirCostMidYear); // BG
    tirCostLastYearValues[anno - 1] = getTirCostValue(anno, tirCostLastYear); // BH
  }

  tirCostFirstYearValues =
    Math.round(IRR(tirCostFirstYearValues) * 100 * 100) / 100; // BE8
  tirCostMidYearValues =
    Math.round(IRR(tirCostMidYearValues) * 100 * 100) / 100; // BE9
  tirCostLastYearValues =
    Math.round(IRR(tirCostLastYearValues) * 100 * 100) / 100; // BE10

  return {
    data,
    tir: {
      tirCostFirstYearValues,
      tirCostMidYearValues,
      tirCostLastYearValues
    }
  };
}

// Engine functions
function getPremioResiduoInvestimento() {
  // D24
  return (
    (PUIniziale -
      imposteSuiPremiInfortuni * (premioFamilyCare + premioACMAPU) -
      dirittiEmissione +
      Math.pow(
        Math.pow(
          PUIniziale -
            imposteSuiPremiInfortuni * (premioFamilyCare + premioACMAPU) -
            dirittiEmissione,
          2
        ) -
          4 *
            imposteSuiPremiInfortuni *
            dirittiEmissione *
            (premioFamilyCare + premioACMAPU),
        0.5
      )) /
      2 -
    (premioFamilyCare + premioTCMPU + premioACMAPU)
  );
}

function getPremio(anno) {
  // J
  return anno === 1 ? getPremioResiduoInvestimento() : 0;
}

function getGS(anno) {
  // X
  // return getScenario("gesav", scenario, anno);
  // @LC 20200401
  var tutela = getScenarioAgg(
    servizioBilancia,
    true,
    "tutelaClima",
    scenario,
    anno
  );
  var pari = getScenarioAgg(
    servizioBilancia,
    true,
    "pariOpportunita",
    scenario,
    anno
  );
  var consumo = getScenarioAgg(
    servizioBilancia,
    true,
    "consumoResponsabile",
    scenario,
    anno
  );
  var salute = getScenarioAgg(
    servizioBilancia,
    true,
    "saluteBenessere",
    scenario,
    anno
  );
  var crescita = getScenarioAgg(
    servizioBilancia,
    true,
    "crescitaSostenibile",
    scenario,
    anno
  );
  var gs =
    tutela * tutelaClima +
    pari * pariOpportunita +
    consumo * consumoResponsabile +
    salute * saluteBenessere +
    crescita * crescitaSostenibile;
  return gs;
}

function getOvp(anno) {
  // R
  return Math.max(
    0,
    (0.003 * (Math.floor(getGS(anno) * 1000) - 0.04 * 1000)) / 10
  );
}

function getRetrocessoGestione(anno) {
  // S
  return getGS(anno) - trattenutoGS - getOvp(anno);
}

function getCapitaleInizialeLordoDiritti(anno) {
  // T
  return getPremio(anno)
    ? getPremio(anno) - getCifraFissa(anno) - getDiritti(anno)
    : 0;
}

function getDiritti(anno) {
  // U
  if (anno === 1) {
    return 10;
  } else {
    return 0;
    // return getPremio(anno) ? dirittiEmissioneVA : 0;
  }
}

function getCifraFissa(anno) {
  // V
  if (anno === 1) {
    return caricamentoPU;
  } else {
    return getPremio(anno) ? caricamentoVA : 0;
  }
}

function getC0MinMorte(anno) {
  // W
  return investimentoGS * getCapitaleInizialeLordoDiritti(anno);
}

function sumC0MinMorte(anno) {
  let sum = 0;
  for (let i = 1; i <= anno; i++) {
    sum += getC0MinMorte(i);
  }
  return sum;
}

function getGSIniziale(yyyy) {
  // X
  // if (anno === 1) {
  //   return investimentoGS * getCapitaleInizialeLordoDiritti(anno);
  // } else {
  //   return (
  //     getGSFinale(anno - 1) +
  //     investimentoGS * getCapitaleInizialeLordoDiritti(anno)
  //   );
  // }
  if (yyyy === 1) {
    return (
      investimentoGS * (getPremioResiduoInvestimento() + getDiritti(yyyy)) -
      dirittiEmissionePU -
      (caricamentoPU * investimentoGS)
    );
  } else {
    return data.filter(d => d.anno === yyyy - 1)[0].GSFinale;
  }
}

function getGSFinale(yyyy) {
  // AD
  // return getGSIniziale(yyyy) * (1 + getRetrocessoGestione(yyyy));
  return (
    getGSIniziale(yyyy) * (1 + (getGS(yyyy) - trattenutoGS - getOvp(yyyy)))
  );
}

function getTutelaClimaIniziale(yyyy) {
  // Y
  if (yyyy === 1) {
    return (coUL - coTransf) * tutelaClima;
  } else {
    return data.filter(d => d.anno === yyyy - 1)[0]
      .fineUnitPostRivalBilanciaTutelaClimaValue;
  }
  // if (anno === 1) {
  //   return (
  //     getCapitaleInizialeLordoDiritti(anno) * investimentoOICR * tutelaClima
  //   );
  // } else {
  //   return (
  //     getCapitaleInizialeLordoDiritti(anno) * investimentoOICR * tutelaClima +
  //     getTutelaClimaFinale(anno - 1)
  //   );
  // }
}

function getTutelaClimaFinale(yyyy) {
  // AE
  const scenarioVal = getScenarioAgg(
    servizioBilancia,
    false,
    "tutelaClima",
    scenario,
    yyyy
  );
  const value =
    (1 + scenarioVal - costoOICRTutelaClima - terTransazioneTutelaClima) *
    (1 - commGestMensileTutelaClima);
  // console.log('scenarioVal', scenarioVal);
  // console.log('value', value);
  return getTutelaClimaIniziale(yyyy) * value;
}

function getPariOpportunitaIniziale(yyyy) {
  // Z
  if (yyyy === 1) {
    return (coUL - coTransf) * pariOpportunita;
  } else {
    return data.filter(d => d.anno === yyyy - 1)[0]
      .fineUnitPostRivalBilanciaPariOpportunitaValue;
  }
}

function getConsumoResponsabileIniziale(yyyy) {
  // AA
  if (yyyy === 1) {
    return (coUL - coTransf) * consumoResponsabile;
  } else {
    return data.filter(d => d.anno === yyyy - 1)[0]
      .fineUnitPostRivalBilanciaConsumoResponsabileValue;
  }
}

function getSaluteBenessereIniziale(yyyy) {
  // AB
  if (yyyy === 1) {
    return (coUL - coTransf) * saluteBenessere;
  } else {
    return data.filter(d => d.anno === yyyy - 1)[0]
      .fineUnitPostRivalBilanciaSaluteBenessereValue;
  }
}

function getCrescitaSostenibileIniziale(yyyy) {
  // AC
  if (yyyy === 1) {
    return (coUL - coTransf) * crescitaSostenibile;
  } else {
    return data.filter(d => d.anno === yyyy - 1)[0]
      .fineUnitPostRivalBilanciaCrescitaSostenibileValue;
  }
}

function getPariOpportunitaFinale(anno) {
  // AF
  return (
    getPariOpportunitaIniziale(anno) *
    (1 +
      (getScenarioAgg(
        servizioBilancia,
        false,
        "pariOpportunita",
        scenario,
        anno
      ) -
        costoOICRPariOpportunita -
        terTransazionePariOpportunita)) *
    (1 - commGestMensilePariOpportunita)
  );
}

function getConsumoResponsabileFinale(anno) {
  // AG
  return (
    getConsumoResponsabileIniziale(anno) *
    // (1 + getScenario("consumoResponsabile", scenario, anno)) *
    // @LC 20200401
    // (1 + getScenarioAgg(servizioBilancia, false, "consumoResponsabile", scenario, anno)) *
    // (1 - terTransazioneConsumoResponsabile) *
    // (1 - (terTotaleConsumoResponsabile - terTransazioneConsumoResponsabile))
    // @LC 20200401
    (1 +
      (getScenarioAgg(
        servizioBilancia,
        false,
        "consumoResponsabile",
        scenario,
        anno
      ) -
        costoOICRConsumoResponsabile -
        terTransazioneConsumoResponsabile)) *
    (1 - commGestMensileConsumoResponsabile)
  );
}

function getSaluteBenessereFinale(anno) {
  // AH
  return (
    getSaluteBenessereIniziale(anno) *
    (1 +
      (getScenarioAgg(
        servizioBilancia,
        false,
        "saluteBenessere",
        scenario,
        anno
      ) -
        costoOICRSaluteBenessere -
        terTransazioneSaluteBenessere)) *
    (1 - commGestMensileSaluteBenessere)
  );
}

function getCrescitaSostenibileFinale(anno) {
  // AI
  return (
    getCrescitaSostenibileIniziale(anno) *
    (1 +
      (getScenarioAgg(
        servizioBilancia,
        false,
        "crescitaSostenibile",
        scenario,
        anno
      ) -
        costoOICRCrescitaSostenibile -
        terTransazioneCrescitaSostenibile)) *
    (1 - commGestMensileCrescitaSostenibile)
  );
}

function getPrestazioneTotale(anno) {
  return (
    getFineUnitPostRivalBilanciaFinale(anno) +
    getResiduoGS(anno) +
    getGSFinale(anno)
  );
  // AL
}

function getRiscatto(yyyy) {
  // AM
  // AX = AW + AR
  return (
    getRiscatooGSNettoFisso(yyyy) + getFineUnitPostRivalBilanciaFinale(yyyy)
  );
}

//-----
function getRiscatooGSNettoFisso(yyyy) {
  return (
    (getResiduoGS(yyyy) + getGSFinale(yyyy)) * (1 - getPenaleRiscattoGS(yyyy)) -
    costoRiscatto
  );
}
function getGSFine(yyyy) {
  return getGSIniz(yyyy) * (1 + (getGS(yyyy) - trattenutoGS - getOvp(yyyy)));
}
function getGSIniz(yyyy) {
  if (yyyy === 1) {
    return investimentoGS * PUIniziale - caricamentoPU / 2 - dirittiEmissionePU;
  } else {
    return data.filter(d => d.anno === yyyy - 1)[0].GSFinale;
  }
}

function getPercTeorica(yyyy) {
  const val =
    (investimentoOICR + (investimentoGS2anni / 2) * yyyy) /
    (investimentoOICR + investimentoGS2anni);
  return val < 1 ? val : 1;
}
function getPercULInvestita(yyyy) {
  return (
    (getConsumoResponsabileFinale(yyyy) +
      getTutelaClimaFinale(yyyy) +
      getPariOpportunitaFinale(yyyy) +
      getSaluteBenessereFinale(yyyy) +
      getCrescitaSostenibileFinale(yyyy)) /
    (getConsumoResponsabileFinale(yyyy) +
      getTutelaClimaFinale(yyyy) +
      getPariOpportunitaFinale(yyyy) +
      getSaluteBenessereFinale(yyyy) +
      getCrescitaSostenibileFinale(yyyy) +
      getCapGStrasfRivalFineAnno(yyyy))
  );
}

function ctDaGSaUL(yyyy) {
  //AK
  const percULInvestita = getPercULInvestita(yyyy);
  // const val = (investimentoOICR + investimentoGS2anni / 2 * yyyy) / (investimentoOICR + investimentoGS2anni);
  // const percUlTeorica = val < 1 ? val : 1;
  //AJ - AI
  const percUlTeorica = getPercTeorica(yyyy);
  const val1 =
    percUlTeorica - percULInvestita > 0 ? percUlTeorica - percULInvestita : 0;
  return (
    val1 *
    (getCapGStrasfRivalFineAnno(yyyy) +
      (getConsumoResponsabileFinale(yyyy) +
        getTutelaClimaFinale(yyyy) +
        getPariOpportunitaFinale(yyyy) +
        getSaluteBenessereFinale(yyyy) +
        getCrescitaSostenibileFinale(yyyy)))
  );
}

function getCapGStrasfRivalFineAnno(yyyy) {
  // T6 * 1-N6
  const capInizioGSTranf =
    yyyy === 1 ? coTransf : data.filter(d => d.anno === yyyy - 1)[0].residuoGS;
  const bilancia = servizioBilancia ? 1 : 0;
  return (
    bilancia *
    capInizioGSTranf *
    (1 + getGS(yyyy) - trattenutoGS - getOvp(yyyy))
  );
  //=T5*(1+$N5)
}

function getResiduoGS(yyyy) {
  return getCapGStrasfRivalFineAnno(yyyy) - ctDaGSaUL(yyyy);
}

function getFineUnitPostRivalBilanciaFinale(yyyy) {
  return (
    getFineUnitPostRivalBilanciaTutelaClima(yyyy) +
    getFineUnitPostRivalBilanciaPariOpportunita(yyyy) +
    getFineUnitPostRivalBilanciaSaluteBenessere(yyyy) +
    getFineUnitPostRivalBilanciaConsumoResponsabile(yyyy) +
    getFineUnitPostRivalBilanciaCrescitaSostenibile(yyyy)
  );
}

function getFineUnitPostRivalBilanciaTutelaClima(yyyy) {
  return ctDaGSaUL(yyyy) * tutelaClima + getTutelaClimaFinale(yyyy);
}
function getFineUnitPostRivalBilanciaPariOpportunita(yyyy) {
  return ctDaGSaUL(yyyy) * pariOpportunita + getPariOpportunitaFinale(yyyy);
}
function getFineUnitPostRivalBilanciaSaluteBenessere(yyyy) {
  return ctDaGSaUL(yyyy) * saluteBenessere + getSaluteBenessereFinale(yyyy);
}
function getFineUnitPostRivalBilanciaConsumoResponsabile(yyyy) {
  return (
    ctDaGSaUL(yyyy) * consumoResponsabile + getConsumoResponsabileFinale(yyyy)
  );
}
function getFineUnitPostRivalBilanciaCrescitaSostenibile(yyyy) {
  return (
    ctDaGSaUL(yyyy) * crescitaSostenibile + getCrescitaSostenibileFinale(yyyy)
  );
}

//-----

function getPenaleRiscattoGS(anno) {
  // AK
  let penaleRiscattoGS;
  switch (anno) {
    case 1:
      penaleRiscattoGS = 0.02;
      break;
    case 2:
      penaleRiscattoGS = 0.015;
      break;
    case 3:
      penaleRiscattoGS = 0.01;
      break;
    case 4:
      penaleRiscattoGS = 0.005;
      break;
    default:
      penaleRiscattoGS = 0;
      break;
  }
  return penaleRiscattoGS;
}

function getMorte(anno) {
  // AN
  return (
    Math.max(getGSIniziale(1), getGSFinale(anno)) +
    getResiduoGS(anno) +
    getFineUnitPostRivalBilanciaFinale(anno) * 1.002
  );
}

function getFamilyCare(anno) {
  // AO
  return premioFamilyCare > 0 && anno <= durataFamilyCare
    ? familyCareCopertura
    : 0;
}

function getMortePU(anno) {
  // AP
  return premioTCMPU > 0 && anno <= durataTCMPU ? TCMPUCopertura : 0;
}

function getACMA(anno) {
  // AQ
  if (premioACMAPU && anno <= durataACMAPU) {
    return isACMAAttivabile ? ACMAPUCopertura : ACMAPlusCopertura;
  } else {
    return 0;
  }
}

function getTotaleMorte(anno) {
  // AR
  return getMorte(anno) + getMortePU(anno);
  // getFamilyCare(anno);
}

function getMorteAccidentale(anno) {
  // AS
  return getFamilyCare(anno) + getACMA(anno);
}

function getTirCostValue(anno, targetYear) {
  // BF, BG, BH
  let tirCost = 0;
  if (anno == tirCostFirstYear) {
    // tirCost = -PUIniziale;
    const extra = vuoiTCMPU ? premioTCMPU : 0;
    tirCost = -1 * getPremio(1) - extra;
  } else if (anno - 1 == targetYear) {
    tirCost = getRiscatto(targetYear);
  }
  return tirCost;
}

function getCapitaliComplementari(PUIniziale) {
  // V62 -> V71
  let values = [];
  values[1] = 30000;

  for (let i = 2; i <= 10; i++) {
    const val = Math.min(300000, PUIniziale * 3, values[1] * i);
    if (values.indexOf(val) === -1) {
      values[i] = val;
    }
  }
  values.shift();
  return values;
}

function getACMAIS(PUIniziale) {
  // W62 -> W71
  let values = [];
  values[1] = 15000;

  for (let i = 2; i <= 10; i++) {
    const val = Math.min(150000, PUIniziale * 3, values[1] * i);
    if (values.indexOf(val) === -1) {
      values[i] = val;
    }
  }
  values.shift();
  return values;
}
